<div class="h-100 w-100 position-relative">
  <form [formGroup]="registrationNumberForm">
    <finxone-input
      type="text"
      [label]="dataIn.attri.widgetProperties['inputLabel'] ?? 'Registration number'"
      formControlName="registrationNumber"
      [value]="registrationNumberForm.controls['registrationNumber']?.value ?? ''"
    >
    </finxone-input>
  </form>
</div>
